import React, { useLayoutEffect, useState } from "react";
import { useUserContext } from "src/contexts/userContext";
import * as API from "src/api/request";

import { TreeSelect } from "antd";
import _ from "lodash";

const DepartmentTree = (props) => {
  const { user } = useUserContext();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    API.getUserDepartment().then((res) => {
      var result = [];
      _.map(_.orderBy(res, ["departmentlevelid", "departmentcode"]), (item) => {
        result.push({
          ...item,
          title: item.departmentcode + " | " + item.departmentname,
          key: item.departmentcode,
          value: item.departmentcode,
          id: item.id,
          pId: item.parentid,
          selectable: item.departmentlevelid !== -1,
        });
      });
      setList(result);

      if (res?.length > 0 && !props.value) {
        // Хэрэглэгчийн tseh_code -ийг хайна. Хэрэв хариуцлагатай нэгжид
        // багтахгүй (өөр хэлтсийн хэрэглэгч г.м.) олдохгүй — undefined-ийг
        // .departmentcode уншихаас өмнө шалгана.
        var department = _.find(res, { departmentcode: user?.info?.tseh_code });
        if (department) {
          props.onChange(department.departmentcode);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TreeSelect
      showSearch
      allowClear={true}
      placeholder="Сонгоно уу"
      treeDataSimpleMode={true}
      className="w-full"
      treeData={list}
      treeLine={(true, { showLeafIcon: false })}
      {...props}
      filterTreeNode={(search, item) =>
        item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
      }
      open={open}
      onDropdownVisibleChange={(open) => setOpen(open)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          var department = _.find(list, {
            departmentcode: e.target.value,
          });

          if (department) {
            props.onChange(department.departmentcode);
            setOpen(false);
          }
        }
      }}
    />
  );
};

export default React.memo(DepartmentTree);
